import { useSidebar } from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";
import { Menu } from "lucide-react";

export function MobileMenuButton() {
  const { isMobile, toggleSidebar, openMobile } = useSidebar();

  if (!isMobile) {
    return null;
  }

  return (
    <button
      onClick={toggleSidebar}
      className={cn(
        "fixed z-50 bottom-4 right-4 md:hidden",
        "flex items-center justify-center",
        "h-14 w-14 rounded-full",
        "overflow-hidden text-white shadow-lg",
        "bg-gradient-to-br from-[#2b7fff] to-[#fe9a00]",
        "transition-all duration-300 ease-in-out",
        "hover:scale-105 active:scale-95",
        "focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2",
        openMobile && "rotate-90",
        "translate-y-0 opacity-100"
      )}
      aria-label="Toggle sidebar menu"
    >
      {/* Animated gradient background */}
      <div className="absolute inset-0 rounded-full bg-gradient-to-r from-[#2b7fff] via-[#fe9a00] to-[#2b7fff] bg-[length:200%_100%] animate-gradient-x" />

      <Menu className="h-6 w-6 relative z-10" />
      <span className="sr-only">Menu</span>

      {/* Ripple effect */}
      <span
        className={cn(
          "absolute inset-0 rounded-full",
          "bg-white/10",
          openMobile ? "animate-ping" : "animate-none",
          "opacity-75 z-0"
        )}
      />
    </button>
  );
}
